import React, { Component } from "react";
import { Field, reduxForm, formValueSelector } from "redux-form";
import RaisedButton from "material-ui/RaisedButton";
import { TextField, SelectField } from "redux-form-material-ui";
import Dialog from "material-ui/Dialog";
import Toggle from "material-ui/Toggle";
import MenuItem from "material-ui/MenuItem";
import { connect } from "react-redux";

import {
  maxLength,
  email,
  validators,
  required,
  isFloat,
  isInteger,
  slug,
} from "../../services/form";
import { updateGlobalConfig, deleteConfig, updateAgeLimits } from "./actions";

import "../common.css";

const renderToggle = ({ input, label }) => (
  <Toggle
    label={label}
    toggled={input.value ? true : false}
    onToggle={input.onChange}
  />
);

class GlobalConfig extends Component {
  state = {
    openDeleteScreen: false,
  };

  componentDidMount() {}

  render() {
    const {
      slugs,
      rankings,
      handleSubmit,
      submitCb,
      deleteConfig,
      updateAgeLimits,
      merchantCode,
      lang,
      kind,
    } = this.props;
    const styles =
      window && window.innerWidth > 768
        ? {
            width: "calc(90vw - 240px)",
            margin: "0 20px 0 260px",
          }
        : {};
    const submit = (values) => submitCb(merchantCode, values, lang);
    return (
      <div className="card-container">
        <div className="card">
          <div className="title">Configuration globale</div>
          <div className="inner">
            <form onSubmit={handleSubmit(submit)}>
              <div className="fieldset">
                <Field
                  name="name"
                  floatingLabelText="Intitulé"
                  component={TextField}
                  validate={validators([required, maxLength(255)])}
                />
                <Field
                  name="slug"
                  floatingLabelText="Slug"
                  component={TextField}
                  validate={validators([slug(slugs), maxLength(255)])}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="kind"
                  floatingLabelText="Type d'hébergement"
                  component={SelectField}
                  validate={required}
                >
                  <MenuItem value="HOTEL" primaryText="Hôtel" />
                  <MenuItem value="MEUBLE" primaryText="Meublé" />
                  <MenuItem value="RESIDENCE" primaryText="Résidence" />
                  <MenuItem
                    value="RESIDENCE-CLUB"
                    primaryText="Résidence-club"
                  />
                  <MenuItem value="CAMPING" primaryText="Camping" />
                  <MenuItem value="CHAMBRE_HOTE" primaryText="Chambre d'hôte" />
                </Field>
                {kind === "MEUBLE" ? (
                  <Field
                    name="meuble_kind"
                    floatingLabelText="Type de meublé"
                    component={SelectField}
                    validate={required}
                  >
                    <MenuItem value="APT" primaryText="Appartement" />
                    <MenuItem
                      value="APT-IN-CHALET"
                      primaryText="Appartement dans chalet"
                    />
                    <MenuItem value="CHALET" primaryText="Chalet" />
                    <MenuItem value="GITE-RURAL" primaryText="Gîte rural" />
                    <MenuItem value="CLEVACANCES" primaryText="Clévacances" />
                    <MenuItem
                      value="GITE-FRANCE"
                      primaryText="Gîte de France"
                    />
                  </Field>
                ) : (
                  <div className="field-spacer" />
                )}
              </div>
              <div className="fieldset">
                <Field
                  name="apidae"
                  floatingLabelText="Code Apidae"
                  component={TextField}
                  validate={maxLength(20)}
                />
                <Field
                  name="ospita"
                  floatingLabelText="Code Ospita"
                  component={TextField}
                  validate={maxLength(20)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="othyssia"
                  floatingLabelText="Code Othyssia"
                  component={TextField}
                  validate={maxLength(20)}
                />
                <Field
                  name="source"
                  floatingLabelText="Fournisseur"
                  component={SelectField}
                  validate={required}
                >
                  <MenuItem value="KOEDIA" primaryText={"Koedia"} />
                  <MenuItem value="MY-MEUBLE" primaryText={"MyMeublé"} />
                  <MenuItem value="MAEVA" primaryText={"Maeva"} />
                  <MenuItem value="LHW" primaryText={"LHW"} />
                  <MenuItem value="LBM" primaryText={"iResa"} />
                  <MenuItem value="ELLOHA" primaryText={"Elloha"} />
                </Field>
              </div>
              <div className="fieldset">
                <Field
                  name="max_age_infant"
                  floatingLabelText="Age maximum bébé"
                  component={TextField}
                  validate={isInteger}
                  disabled
                />
                <Field
                  name="max_age_child"
                  floatingLabelText="Age maximum enfant"
                  component={TextField}
                  validate={isInteger}
                  disabled
                />
              </div>
              <div className="fieldset">
                <Field
                  name="email"
                  floatingLabelText="Email de contact"
                  component={TextField}
                  validate={validators([email, maxLength(255)])}
                />
                <Field
                  name="phone"
                  floatingLabelText="Téléphone"
                  component={TextField}
                  validate={maxLength(30)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="ranking_id"
                  floatingLabelText="Classement"
                  component={SelectField}
                  validate={required}
                >
                  {rankings
                    .sort((r1, r2) => {
                      return r1.rank > r2.rank;
                    })
                    .map((ranking) => {
                      return (
                        <MenuItem
                          key={ranking.ranking_id}
                          value={ranking.ranking_id}
                          primaryText={ranking.libelle}
                        />
                      );
                    })}
                </Field>
                <div className="field-spacer" />
              </div>
              <div className="fieldset">
                <Field
                  name="address1"
                  floatingLabelText="Adresse 1"
                  component={TextField}
                  validate={maxLength(255)}
                />
                <Field
                  name="address2"
                  floatingLabelText="Adresse 2"
                  component={TextField}
                  validate={maxLength(255)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="cp"
                  floatingLabelText="Code postal"
                  component={TextField}
                  validate={maxLength(8)}
                />
                <Field
                  name="city"
                  floatingLabelText="Ville"
                  component={TextField}
                  validate={maxLength(255)}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="nb_rooms"
                  floatingLabelText="Nombre de pièces"
                  component={TextField}
                  validate={isInteger}
                />
                <Field
                  name="max_capacity"
                  floatingLabelText="Capacité maximum"
                  component={TextField}
                  validate={isInteger}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="surface"
                  floatingLabelText="Surface en m2"
                  component={TextField}
                  validate={isFloat}
                />
                <Field
                  name="nb_bedrooms"
                  floatingLabelText="Nombre de chambres"
                  component={TextField}
                  validate={isInteger}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="nb_bathrooms"
                  floatingLabelText="Nombre de salles de bain"
                  component={TextField}
                  validate={isInteger}
                />
                <Field
                  name="nb_restrooms"
                  floatingLabelText="Nombre de toilettes"
                  component={TextField}
                  validate={isInteger}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="floor_nb"
                  floatingLabelText="Etage"
                  component={TextField}
                  validate={isInteger}
                />
                <Field
                  name="double_beds"
                  floatingLabelText="Nombre de lits doubles"
                  component={TextField}
                  validate={isInteger}
                />
              </div>
              <div className="fieldset">
                <Field
                  name="single_beds"
                  floatingLabelText="Nombre de lits simples"
                  component={TextField}
                  validate={isInteger}
                />
                <Field
                  name="bunk_beds"
                  floatingLabelText="Lits superposés"
                  component={TextField}
                  validate={isInteger}
                />
              </div>
              <div className="fieldset toggle-outer fieldset-toggle">
                <Field
                  name="couches"
                  label="Canapés convertibles"
                  labelPosition="left"
                  component={renderToggle}
                />
              </div>
              <div className="fieldset toggle-outer fieldset-toggle">
                <Field
                  name="all_inclusive"
                  label="Village Club du Soleil"
                  labelPosition="left"
                  component={renderToggle}
                />
              </div>
              {kind === "MEUBLE" ? (
                <div className="fieldset toggle-outer fieldset-toggle">
                  <Field
                    name="chalet_moniteur"
                    label="Est un chalet de moniteur"
                    labelPosition="left"
                    component={renderToggle}
                  />
                </div>
              ) : undefined}
              <div className="action-btns">
                <RaisedButton
                  secondary
                  className="update-age-config-btn"
                  label="MAJ des limites d'âges"
                  onClick={updateAgeLimits(merchantCode, lang)}
                />
                <RaisedButton
                  secondary
                  className="delete-config-btn"
                  label="Supprimer"
                  onClick={() => this.setState({ openDeleteScreen: true })}
                />
                <RaisedButton
                  type="submit"
                  secondary
                  className="global-form-validate-btn"
                  label="Valider"
                />
              </div>
            </form>
            <Dialog
              title={"Suppression de la configuration hébergement"}
              actions={[
                <RaisedButton
                  className="button"
                  label={"Confirmer"}
                  onClick={deleteConfig(merchantCode)}
                  secondary
                />,
              ]}
              modal={false}
              open={this.state.openDeleteScreen}
              onRequestClose={() => this.setState({ openDeleteScreen: false })}
              contentStyle={styles}
            >
              Êtes-vous sur de vouloir effectuer cette action ?
            </Dialog>
          </div>
        </div>
      </div>
    );
  }
}

GlobalConfig = reduxForm({
  form: "GlobalConfig",
  enableReinitialize: true,
})(GlobalConfig);

const selector = formValueSelector("GlobalConfig"); // <-- same as form name
GlobalConfig = connect((state) => {
  const kind = selector(state, "kind");
  return {
    kind,
  };
})(GlobalConfig);
/********* Container part */

const mapStateToProps = (state) => ({
  initialValues: state.accomodation,
  merchantCode: state.merchant.detail.code,
  isAdmin: state.app.auth.user.isAdmin,
  lang: state.accomodation.lang,
  rankings: state.accomodation.rankings,
  slugs: state.accomodation.slugs,
});

const mapDispatchToProps = (dispatch) => ({
  submitCb: (merchantCode, values, lang) => {
    dispatch(updateGlobalConfig(merchantCode, values, lang));
  },
  deleteConfig: (merchantCode) => () => {
    dispatch(deleteConfig(merchantCode));
  },
  updateAgeLimits: (merchantCode, lang) => () => {
    dispatch(updateAgeLimits(merchantCode, lang));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GlobalConfig);



// WEBPACK FOOTER //
// ./src/merchant/accomodation/GlobalConfig.js